import swal from "sweetalert";
import axiosInstance from "../api";
import { setSingleWalletValidity, setWalletList, setWalletValidityList } from "../../reusableSlice";


export const addWallet = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("admin/wallets/", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/wallet/list")
      return response;
    }
    else{
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};


export const addUserWallet = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("admin/wallets/", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      
      // navigate("/wallet/list")
      return response;
    }
    else{
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const getAllWallet = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/wallets/", { params: data });
      console.log(response,"sdfsf")
      if (response?.data) {
        dispatch(setWalletList(response?.data?.response))
      } else {
        dispatch(setWalletList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setWalletList([]))
    }
  };



  //  wallet validity

  export const getAllWalletValidity = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/wallets/validity", { params: data });
      console.log(response,"sdfsf")
      if (response?.data) {
        dispatch(setWalletValidityList(response?.data?.response))
      } else {
        dispatch(setWalletValidityList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setWalletValidityList([]))
    }
  };


  export const addWalletValidity = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("admin/wallets/validity", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/wallet/validities/list")
      return response;
    }
    else{
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};


export const getSingleWalletValidity = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/wallets/validity/${id}`);
      // console.log(response,"responsesdfssfs")
      if (response?.data) {
        dispatch(setSingleWalletValidity(response?.data?.response))
      } else {
        dispatch(setSingleWalletValidity([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setSingleWalletValidity([]))
    }
  };

   export const updateOneWalletValidity = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("admin/wallets/validity", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/wallet/validities/list")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };